module.exports = __webpack_public_path__ + "static/new5pic2-480c1fdff225f25c1fe539729c66e153.jpg";